import axios from '@axios'

export default {
  namespaced: true,
  state: {
    status: '',
    user: {},
  },
  getters: {
    status: state => state.user.status,
  },
  mutations: {
    auth_success(state, user) {
      state.user = user
      state.status = true
    },
    logout(state) {
      state.status = false
    },
  },
  actions: {
    async login({ commit }, { username, password }) {
      try {
        const res = await axios.post('/loginNPT', { username, password })
        localStorage.setItem('userData', JSON.stringify(res.data))
        commit('auth_success', res.data)
      } catch (error) {
        console.error(error.message)
        commit('logout')
        this.$message.error(error.message)
      }
    },
    // LOG OUT //
    logout({ commit }) {
      commit('logout')
      localStorage.removeItem('userData')
    },
    bypass({ commit }) {
      const user = {
        status: 0, message: 'Login successful', uid: 1, username: 'npt-admin', firstname: 'System', lastname: 'Admin', groupname: 'Admin', token: 'EWFTYgsdthry4', role: 'admin',
      }
      localStorage.setItem('userData', JSON.stringify(user))
      commit('auth_success', user)
    },
  },
}
